import articleApi from 'api/article';
import events from 'lib/events';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import SearchField from 'components/searchField';
import session from 'services/sessionService';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import IntlWrapper from 'components/layout/intlWrapper';
import Header from 'components/layout/header';
import SearchResults from 'components/searchResults';
import ArticleContents from 'components/articles/articleContents';

let render = container => {
  console.info('[UI.page.encyclopedia] rendering page');
  let {query, topic} = session.popSearch();

  ReactDOM.render(<IntlWrapper><WrappedEncyclopediaPage query={query} topic={topic} /></IntlWrapper>, container);
  events.publish('page-change', {page: 'encyclopedia'});
};

console.info('[UI.page.encyclopedia] register route');
router.rr.add([{path: 'encyclopedia', handler: routeUtils.requireAuth(render)}]);

// Page object
class EncyclopediaPage extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      topic: props.topic || '',
      query: '',
      page: 1,
      results: {},
      videosOnly: false,
      article: null,
      topics: [],
    };
  }

  componentWillMount() {
    events.subscribe('supportclear', () => {
      this.revertSearch();
    });

    if (this.props.query) {
      this.filterChange(this.props.query);
    }

    articleApi.getEncyclopediaTopics()
      .then(topics => this.setState({topics: topics}));
  }

  onPageChange = page => this.setState({page: page}, this.performSearch);

  changeHandler = (property, after = null, valueProperty = 'value') =>
    event =>
      this.setState({
        [property]: event.target[valueProperty],
      }, after || (() => {
      }));

  filterChange = term => {
    this.setState({query: term, page: 1}, this.performSearch);
  };

  navigateToArticle = slug => {
    window.location.hash = `encyclopedia/${slug}`;
  };

  performSearch = () => {
    this.setState({results: null});
    articleApi.searchEncyclopediaArticles(this.state.query, this.state.topic, this.state.page, this.state.videosOnly)
      .then(results => this.setState({results}));

    events.publish('ga.event', {category: 'Search', action: 'enc-search-' + this.state.topic});
  };

  revertSearch = () => {
    this.setState({query: ''});
  };

  toggleVideoFilter = () => this.setState(prevState => ({
    videosOnly: !prevState.videosOnly,
    page: 1,
  }), this.performSearch);

  topicChange = () => this.setState({page: 1}, this.performSearch);

  render() {
    let isSearching = this.state.query && this.state.query.length || this.state.topic;
    let searchResults = this.state.results;
    let {formatMessage} = this.props.intl;

    return <div className='page-encyclopedia container'>
      <Header mainTitle={formatMessage({id: 'encyclopedia.title'})}
              mainTitleReturn='encyclopedia'
              subTitle={isSearching ? formatMessage({id: 'general.search.results'}) : ''}/>
      <div className='well clearfix'>
        <div className='col-sm-4'>
          <SearchField placeholder={formatMessage({id: 'general.search.articles.keyboards'})}
                       onSearch={this.filterChange}
                       initialValue={this.state.query}/>
        </div>
        <div className='col-sm-4'>
          <div className='form-group'>
            <select className='form-control'
                    value={this.state.topic}
                    onChange={this.changeHandler('topic', this.topicChange)}>
              <option value=''><FormattedMessage id="general.select.topic"/></option>
              {this.state.topics.map(topic => <option key={topic.ID}
                                                      value={topic.Name}>{topic.Name}</option>)}
            </select>
          </div>
        </div>
      </div>

      {!isSearching ?
        this.state.article ?
          <ArticleContents article={this.state.article}
                           formatMessage={formatMessage}/> :
          <div><FormattedMessage id='encyclopedia.overview.body' /></div> :
          <SearchResults {...searchResults} baseUrl='encyclopedia/'
                         query={this.state.query}
                         onResultClick={article => this.navigateToArticle(article.slug)}
                         onPageChange={this.onPageChange}
                         enableVideoFilter={true}
                         onVideoFilterToggle={this.toggleVideoFilter}
                         videosOnly={this.state.videosOnly}
                         formatMessage={formatMessage}/>}
    </div>;
  }
}

let WrappedEncyclopediaPage = injectIntl(EncyclopediaPage);

export default WrappedEncyclopediaPage;
